// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal___c4SLq{width:100%;max-width:496px}\n", "",{"version":3,"sources":["webpack://./src/components/RulesHeader/ScheduledDeploymentModal/ScheduledDeploymentModal.css"],"names":[],"mappings":"AAAA,eACI,UAAA,CACA,eAAA","sourcesContent":[".modal {\n    width: 100%;\n    max-width: 496px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": "modal___c4SLq"
};
export default ___CSS_LOADER_EXPORT___;
